import { useTypography } from '@app/shared/styles/typography';
import { Typography } from '@material-ui/core';
import { TypographyProps } from '@material-ui/core/Typography';
import React from 'react';

export const PageHeader = (props: TypographyProps) => {
  const typographyClasses = useTypography();
  return <Typography variant="h5" color="primary" className={typographyClasses.pageTitle} {...props} />;
};
